export const GET_MAP_STATES = 'GET_MAP_STATES'
export const STATES_FOR_SELECT = 'STATES_FOR_SELECT'
export const GET_STATES = 'GET_STATES'
export const MAP_LOADING = 'MAP_LOADING'
export const GET_MAP_STATE_CONTACTS = 'GET_MAP_STATE_CONTACTS'
